var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vb-checkout"},[_c('pratica',{attrs:{"services":_vm.quote.services,"passengers":_vm.passengers.passengers}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }